export function $$<T extends Element>(
    query: string,
    container: Element | Document = document,
): T[] {
    const list: NodeList = container.querySelectorAll(query);

    return [].slice.call(list);
}
